import { getApi } from 'apis';

export const getAllPayPoints = async (params: any) => {
	return await getApi('/payPoint', params);
};
